import { GeneralConfig } from "./general-config";
import { SmpaConfig } from "./smpa";
import { TradingConfig } from "./trading";
import { TradingViewConfig } from "./tv-config";
export enum ScopeIds {
	BodyStr,
	WickStr
}

export interface SettingsScope {
	tz: string;
	chart: ChartConfig;
	general: GeneralConfig;
	templates: string[];
}

export interface ChartConfig {
	scopeId: ScopeIds;
	smpa: SmpaConfig;
	tv: TradingViewConfig;
	trading: TradingConfig;
}
export interface DefaultSettings {
	general: GeneralConfig;
	chart: ChartConfig;
}
